import { Injectable } from '@angular/core';

import { createFeatureSelector, createSelector, Store } from '@ngrx/store';

import * as reducer from '../reducers/languages.reducer';
import { IAppState } from '../states/app.state';

export const languagesFeatureSelector = createFeatureSelector<reducer.IState>(reducer.featureKey);

export const selectLanguagesState = createSelector(languagesFeatureSelector, (state) => state.langs);
export const selectAllLanguages = createSelector(selectLanguagesState, reducer.selectAllLanguages);
export const selectSelectedLanguage = createSelector(selectLanguagesState, (state) => {
  return state.selected;
});
export const selectSelectedLanguageData = createSelector(selectLanguagesState, (state) => {
  return reducer.selectAllLanguages(state).find((x) => x.Code === state.selected);
});
export const selectSelectedLanguageCode = createSelector(selectSelectedLanguage, (state) => {
  return state ?? 'en';
});
export const selectLanguagesWithSelected = createSelector(selectLanguagesState, (state) => {
  const languages = reducer.selectAllLanguages(state);
  const selected = languages.find((x) => x.Code === state.selected);
  return {
    languages: languages.sort((x) => (x.Code === selected?.Code ? -1 : 1)),
    selected: selected,
  };
});

export const selectLocalizationState = createSelector(languagesFeatureSelector, (state) => state.localization);
export const selectAllLocalizations = createSelector(selectLocalizationState, reducer.selectAllLocalization);
export const selectDev = createSelector(selectLocalizationState, (state) => state.dev);
export const selectLocalizationIsLoading = createSelector(selectLocalizationState, (state) => state.isLoading);
@Injectable({
  providedIn: 'root',
})
export class LanguagesSelectService {
  constructor(private _store$: Store<IAppState>) {}

  getLocalizations() {
    return this._store$.select(selectAllLocalizations);
  }

  getLocalizationsLoading() {
    return this._store$.select(selectLocalizationIsLoading);
  }

  getDev() {
    return this._store$.select(selectDev);
  }

  getLanguages() {
    return this._store$.select(selectAllLanguages);
  }

  getSelected() {
    return this._store$.select(selectSelectedLanguage);
  }

  getSelectedCode() {
    return this._store$.select(selectSelectedLanguageCode);
  }

  getLanguagesWithSelected() {
    return this._store$.select(selectLanguagesWithSelected);
  }
}
